// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.allgemeine-information-page-container {
    display: flex;
    justify-content: flex-start; /* Align to the start of the container, which is left by default */
    align-items: center;
    width: 100%;
    font-family: 'Poppins', sans-serif; /* Apply the Poppins font */
    font-size: 12px;
  }
  
  /* Apply a bold font weight to all header cells in the table */
  .rsuite-table .rs-table-header-cell-wrapper {
    font-weight: bold;
  }
  
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw; /* Ensuring the overlay takes the full viewport width */
    height: 100vh; /* Ensuring the overlay takes the full viewport height */
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background to dim the content behind */
    z-index: 1000; /* High z-index to keep the overlay above other elements */
  }
  
  .overlay-iframe-container {
    position: relative;
    width: 80vw;
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    /* Add any additional styles for the container here */
  }
  
  .overlay-iframe {
    width: 100%; /* Will take the full width of the container */
    height: 100%; /* Will take the full height of the container */
    border-radius: 15px;
    /* Remove padding if the iframe should go to the edges */
    /* Add any additional styles for the iframe here */
  }
  
  .overlay-close-btn {
    position: absolute;
    top: 10px; /* Adjust the value as needed */
    right: 10px; /* Adjust the value as needed */
    background: #ff6347;
    color: white;
    border: none;
    border-radius: 50%;
    width: 35px; /* Increase the size if needed */
    height: 35px; /* Increase the size if needed */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 10; /* Higher than the iframe to ensure it's clickable */
    /* Remove text-indent if using text content for the button */
  }
  
  .overlay-close-btn:hover {
    background-color: #e55347;
    transform: scale(1.1);
  }
  
  .overlay-close-btn::before {
    content: '\\00d7'; /* 'X' symbol */
    font-size: 32px; /* Large size for visibility */
    line-height: 1;
  }`, "",{"version":3,"sources":["webpack://./src/widgets/BewertungAllgemeineInformatiWidgets.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B,EAAE,kEAAkE;IAC/F,mBAAmB;IACnB,WAAW;IACX,kCAAkC,EAAE,2BAA2B;IAC/D,eAAe;EACjB;;EAEA,8DAA8D;EAC9D;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY,EAAE,uDAAuD;IACrE,aAAa,EAAE,wDAAwD;IACvE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B,EAAE,0DAA0D;IAC1F,aAAa,EAAE,0DAA0D;EAC3E;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD;EACvD;;EAEA;IACE,WAAW,EAAE,8CAA8C;IAC3D,YAAY,EAAE,+CAA+C;IAC7D,mBAAmB;IACnB,wDAAwD;IACxD,kDAAkD;EACpD;;EAEA;IACE,kBAAkB;IAClB,SAAS,EAAE,+BAA+B;IAC1C,WAAW,EAAE,+BAA+B;IAC5C,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW,EAAE,gCAAgC;IAC7C,YAAY,EAAE,gCAAgC;IAC9C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,wCAAwC;IACxC,WAAW,EAAE,oDAAoD;IACjE,4DAA4D;EAC9D;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB,EAAE,eAAe;IACjC,eAAe,EAAE,8BAA8B;IAC/C,cAAc;EAChB","sourcesContent":[".allgemeine-information-page-container {\r\n    display: flex;\r\n    justify-content: flex-start; /* Align to the start of the container, which is left by default */\r\n    align-items: center;\r\n    width: 100%;\r\n    font-family: 'Poppins', sans-serif; /* Apply the Poppins font */\r\n    font-size: 12px;\r\n  }\r\n  \r\n  /* Apply a bold font weight to all header cells in the table */\r\n  .rsuite-table .rs-table-header-cell-wrapper {\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw; /* Ensuring the overlay takes the full viewport width */\r\n    height: 100vh; /* Ensuring the overlay takes the full viewport height */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background to dim the content behind */\r\n    z-index: 1000; /* High z-index to keep the overlay above other elements */\r\n  }\r\n  \r\n  .overlay-iframe-container {\r\n    position: relative;\r\n    width: 80vw;\r\n    height: 80vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* Add any additional styles for the container here */\r\n  }\r\n  \r\n  .overlay-iframe {\r\n    width: 100%; /* Will take the full width of the container */\r\n    height: 100%; /* Will take the full height of the container */\r\n    border-radius: 15px;\r\n    /* Remove padding if the iframe should go to the edges */\r\n    /* Add any additional styles for the iframe here */\r\n  }\r\n  \r\n  .overlay-close-btn {\r\n    position: absolute;\r\n    top: 10px; /* Adjust the value as needed */\r\n    right: 10px; /* Adjust the value as needed */\r\n    background: #ff6347;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 35px; /* Increase the size if needed */\r\n    height: 35px; /* Increase the size if needed */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    z-index: 10; /* Higher than the iframe to ensure it's clickable */\r\n    /* Remove text-indent if using text content for the button */\r\n  }\r\n  \r\n  .overlay-close-btn:hover {\r\n    background-color: #e55347;\r\n    transform: scale(1.1);\r\n  }\r\n  \r\n  .overlay-close-btn::before {\r\n    content: '\\00d7'; /* 'X' symbol */\r\n    font-size: 32px; /* Large size for visibility */\r\n    line-height: 1;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
